// extracted by mini-css-extract-plugin
export default {"TestsPage":"TestsPage_TestsPage__psfAa","TestsPage__image":"TestsPage_TestsPage__image__uEnsr","TestsPage__text":"TestsPage_TestsPage__text__4f7bA"};